/**
 * Created by mongoose on 7/11/17.
 */
import React from "react";
import PropTypes from "prop-types";
import WidgetRenderer from "../Common/WidgetRenderer";

function Cell({ field, entity, entities, validation, renderers }) {
  const fieldName = field.fieldName;
  const fieldType = validation && validation.type;
  if (
    renderers &&
    renderers.hasOwnProperty(fieldName) &&
    typeof renderers[fieldName] === "function"
  ) {
    return renderers[fieldName]({ field, entity, entities, fieldType });
  }
  return (
    <WidgetRenderer
      field={field}
      entity={entity}
      entities={entities}
      validation={validation}
      rendererType={field.widget || null}
      fieldType={fieldType}
      caller={"list"}
    />
  );
}

Cell.propTypes = {
  fields: PropTypes.array,
  entities: PropTypes.array,
  validation: PropTypes.object,
  renderers: PropTypes.object,
};

export default React.memo(Cell);
